import { Drawer } from '@mui/material';
import AgentConfiguration from './AgentConfiguration';
import { FC } from 'react';
import MessagePopup from '../../../common/MessagePopup';
import { useAlert } from '../../../../hooks/useAlert';

interface ConfigurationDrawerProps {
  open: boolean;
  onClose: () => void;
}

const ConfigurationDrawer: FC<ConfigurationDrawerProps> = ({
  open,
  onClose,
}) => {
  const { alert, setAlert } = useAlert();

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: '500px',
            height: '100%',
            backgroundColor: '#FFF',
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
          },
        }}
      >
        <AgentConfiguration
          isDrawer
          onClose={onClose}
          alert={alert}
          setAlert={setAlert}
        />
      </Drawer>
      <MessagePopup alert={alert} setAlert={setAlert} />
    </>
  );
};

export default ConfigurationDrawer;
